import dayjs from "dayjs";

export const INFINITE_SCROLL_LIMIT = 30;

export const DEFAULT_CREATED_AT_MIN: string = dayjs().subtract(3, "month").format("YYYY-MM-DD");
